import {createContext, useCallback, useContext, useEffect, useState} from "react";
import baseUrl from "../baseUrl";
import {requester} from "../services/requester";
import {useAppContext} from "./AppContext";

// И2: брой неотговорени въпроси — за значката до „Администрация" в лентата и до
// раздела „Въпроси" в панела.
//
// БЕЗ периодично допитване. На дроплет с 1 vCPU няма причина да се пита сървърът
// на всеки половин минута за нещо, което се случва веднъж седмично. Числото се
// взима веднъж при зареждане и се обновява след всяко действие по въпрос.

export const QuestionsContext = createContext();

export const QuestionsProvider = ({children}) => {
    const {user} = useAppContext();
    const isAdmin = user?.role === 'admin';
    const [unanswered, setUnanswered] = useState(0);

    const refresh = useCallback(() => {
        if (!isAdmin) {
            setUnanswered(0);
            return;
        }
        requester().get(`${baseUrl()}/admin/questions/unanswered-count`)
            .then(data => setUnanswered(data?.count || 0))
            .catch(() => {
                // Значката е удобство — ако не се зареди, екранът не бива да гърми.
            });
    }, [isAdmin]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return (
        <QuestionsContext.Provider value={{unanswered, refresh}}>
            {children}
        </QuestionsContext.Provider>
    );
};

export const useQuestions = () => {
    return useContext(QuestionsContext);
};
